import axios from 'axios';
import { constants } from '../../constants';

export async function removeActivityById(id: string) {
  const token = localStorage.getItem('token');
  await axios.delete(`${constants.endpoint}/activities/${id}`, {
    headers: {
      Authorization: `bearer ${token}`,
    },
  });
}
